<template>
  <v-dialog v-model="dialog" scrollable content-class="rounded-xl">
    <v-card>
      <ImageZoom
        :src="src"
        style="height: 90vh"
        class="rounded-t-xl rounded-b-none"
      />
      <v-card-actions class="justify-center">
        <v-btn text @click="dialog = false"> Fechar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ImageZoom from "./ImageZoom.vue";

export default {
  components: {
    ImageZoom,
  },
  data() {
    return {
      dialog: false,
      src: "",
    };
  },
  methods: {
    open(src) {
      this.dialog = true;
      this.src = src;
    },
  },
  mounted() {
    this.$root.$on("imageViewer", this.open);
  },
  beforeDestroy() {
    this.$root.$off("imageViewer", this.open);
  },
};
</script>
